//Set constant value
export const PERCENT_VALUE = 0; //default percentage value
export const AMT_MIN = 50000; //default sliderMin
export const AMT_MAX = 500000; //default sliderMax
export const AMT_VALUE = 50000; //default value
export const PP_MIN = 50000; //Purchase price min
export const PP_MAX = 500000; //Purchase price max
export const PP_VALUE = 50000; //Purchase price
export const PROPERTY_TAX = 1.25;
export const INSURANCE = 1200;
export const HOME_WARRANTY = 350;
export const YEARS = 30; //years constant
export const secondLoanPercent = 0;
export const secondLoanInterestRate = 4.5;
export const HOA = 300;
export const FED_TAX = 24; //Federal Tax Rate
export const STATE_TAX = 9.30; //State Tax
export const Misc = 0;
export const map = { 94087: "4.00" };
export const ZIP_CODE_CONSTANT = 94087;
export const FIRST_LOAN_RATE = 4.00;
export const zipcodeFlag = false;
export const DP_MIN_PERCENTAGE = 3.5; //down payment min percentage
export const D_MAX_PERCENTAGE = 100; //down payment max percentage
export const SLIDER_MARGIN = 25; //slider margin
export const MAX_MORTGAGE_AMOUNT_FIRST = 750000;
export const CAP_ITEMIZATION_PROPERTY_TAX = 40000;
export const STANDARD_DEDUCTION = 24800;
export const CATEGORIES_ASSETS =  [{
      categoryId: 1,
      account_name: "Cash & Cash Equivalents",
      isStatic: true,
      subcategories: [
        { id:101, name: "Cash on hand", value: null, isStatic: true },
        { id:102, name: "Checking accounts", value: null, isStatic: true },
        { id:103, name: "Savings accounts", value: null, isStatic: true },
        { id:104,name: "Money markets", value: null, isStatic: true },
        {
          id:105,
          name: "Certificates of Deposit",
          value: null,
          isStatic: true,
        },
        { id:106, name: "Other", value: null, isStatic: true },
      ],
    },
    {
      categoryId: 2,
      account_name: "Brokerage Accounts",
      isStatic: true,
      subcategories: [
        { id:201,name: "Stocks", value: null, isStatic: true },
        { id:202,name: "Mutual Funds", value: null, isStatic: true },
        { id:203,name: "Municipal Bonds", value: null, isStatic: true },
        { id:204,name: "Government bonds", value: null, isStatic: true },
        { id:205,name: "Corporate bonds", value: null, isStatic: true },
        { id:206,name: "Other 1", value: null, isStatic: true },
        { id:207,name: "Other 2", value: null, isStatic: true },
      ],
    },
    {
      categoryId: 3,
      account_name: "Retirement Accounts",
      isStatic: true,
      subcategories: [
        { id:301,name: "401(k)", value: null, isStatic: true },
        { id:302,name: "IRA - Roth", value: null, isStatic: true },
        { id:303,name: "IRA - Traditional", value: null, isStatic: true },
        { id:304,name: "Profit Sharing", value: null, isStatic: true },
        { id:305,name: "Pension", value: null, isStatic: true },
      ],
    },
    {
      categoryId: 4,
      account_name: "Property",
      isStatic: true,
      subcategories: [
        { id:401, name: "Primary residence", value: null, isStatic: true },
       /* { name: "Vehicle 1", value: null, isStatic: true },
        { name: "Vehicle 2", value: null, isStatic: true },
        {
          name: "Recreational vehicle 1",
          value: null,
          isStatic: true,
        },
        {
          name: "Recreational vehicle 2",
          value: null,
          isStatic: true,
        },*/
      ],
    },
    {
      categoryId: 5,
      account_name: "Other Assets",
      isStatic: true,
      subcategories: [
        {
          id:501,
          name: "Loans to friends/family",
          value: null,
          isStatic: true,
        },
        {
          id:502,
          name: "Life insurance cash surrender value",
          value: null,
          isStatic: true,
        },
        { id:503,name: "Jewelry", value: null, isStatic: true },
        { id:504,name: "Furnishings", value: null, isStatic: true },
        { id:505,name: "Antiques", value: null, isStatic: true },
        { id:506,name: "Collectables", value: null, isStatic: true },
        { id:507,name: "Other 1", value: null, isStatic: true },
        { id:508,name: "Other 2", value: null, isStatic: true },
      ],
    },
   {
      categoryId: 6,
      account_name: "Commodities",
      isStatic: true,
      subcategories: [
        { id:601,name: "Commodities", value: null, isStatic: true },
      ],
    },
   {
      categoryId: 7,
      account_name: "Cryptocurrency",
      isStatic: true,
      subcategories: [
        { id:701,name: "Cryptocurrency", value: null, isStatic: true },
      ],
    }];
  export const CATEGORIES_LIABILITIES =  [
 {
      categoryId: 1,
      account_name: "Short-Term Credit",
      isStatic: true,
      subcategories: [
        { id:101,name: "Credit card 1", value: null, isStatic: true },
        { id:102,name: "Credit card 2", value: null, isStatic: true },
        { id:103,name: "Credit card 3", value: null, isStatic: true },
        { id:104,name: "Loans from friends/family", value: null, isStatic: true },
        { id:105,name: "Home line of credit", value: null, isStatic: true },
      ],
    },
    {
      categoryId: 2,
      account_name: "Loans & Mortgages",
      isStatic: true,
      subcategories: [
        { id:201,name: "Primary residence", value: null, isStatic: true },
       /* { name: "Vehicle 1", value: null, isStatic: true },
        { name: "Vehicle 2", value: null, isStatic: true },
        { name: "Recreational vehicle 1", value: null, isStatic: true },
        { name: "Recreational vehicle 2", value: null, isStatic: true },
        { name: "Student loans", value: null, isStatic: true },
        { name: "Business loans", value: null, isStatic: true },
        { name: "401(k) loan", value: null, isStatic: true },*/
      ],
    },
    {
      categoryId: 3,
      account_name: "Other Liabilities",
      isStatic: true,
      subcategories: [
        { id:301,name: "Commitment to donate", value: null, isStatic: true },
      ],
    },
    ];


// export const fLPMin = 0; //first loan min
// export const fLPMax = 100 - parseFloat(dPMinPercentage); //first loan max

// export const sLPMin = 0; //second loan min
// export const sLPMax = 10; //second loan max

// export const fRPMin = 1; //first(Rate) min
// export const fRPMax = 100; //first(Rate) max

// export const sRPMin = 1; //second(Rate) min
// export const sRPMax = 100; //second(Rate) max

// export const hOAMin = 0; //HOA min
// export const hOAMax = 100000; //HOA max

// export const pTMin = 1; //Property Tax min
// export const pTMax = 100; //Property Tax max

// export const fTMin = 0; //Federal Tax min
// export const fTMax = 100; //Federal Tax max

// export const sTMin = 0; //State Tax min
// export const sTMax = 100; //State Tax max

// export const insuranceMin = 0; //Insurance Min
// export const insuranceMax = 100000; //Insurance Max

// export const homewarrantyMin = 0; //Home Warranty min
// export const homewarrantyMax = 100000; //Home Warranty max
